export enum ValidatorPanelActions {
  SET_VALIDATOR_DETAILS = "setValidatorDetails",
  TOGGLE_VALIDATOR_PANEL = "toggleValidatorPanel",
  TOGGLE_VALIDATOR_PANEL_APPROVED = "toggleValidatorPanelApproved",
  SET_VALIDATOR_COMMENTS = "setValidatorComments",
  SET_VALIDATOR_HISTORY = "setValidatorHistory",
  ADD_NEW_COMMENT = "addNewComment",
}